<template>
  <el-form
    ref="form"
    class="cargo-form"
    :model="model"
    :rules="rules"
    :inline="inline"
    :label-position="labelPosition"
    label-width="80px"
    :label-suffix="labelSuffix"
    :hide-required-asterisk="hideRequiredAsterisk"
    :show-message="showMessage"
    :inline-message="inlineMessage"
    :status-icon="statusIcon"
    :disabled="disabled"
  >
    <el-row :gutter="10">
      <el-col v-for="item in formItems" :key="item.field" :span="item.span">
        <el-form-item :prop="item.field" :required="item.required" :rules="item.rules" :class="item.label?'':'label-none'">
          <el-tooltip
            v-if="item.label"
            slot="label"
            placement="top"
            :disabled="getLength(item.label)<12"
            effect="dark"
            :content="item.label"
            size="mini"
          >
            <div style="display: flex">
              <span style="flex:1;overflow:hidden;white-space:nowrap;text-overflow: ellipsis;">{{ item.label }}</span>
              <span v-if="labelSuffix">{{ labelSuffix }}</span>
            </div>
          </el-tooltip>
          <!--     单选组     -->
          <el-radio-group v-if="item.type === 'el-radio-group'" v-model="model[item.field]" @change="item.change">
            <el-radio v-for="option in item.options" :key="option.value" :label="option.value">{{ option.label }}</el-radio>
          </el-radio-group>
          <!--    高级下拉      -->
          <cargo-advance-select v-else-if="item.type === 'cargo-advance-select'" :default-value="model[item.field]" v-bind="item.props" @parentCallBack="item.change" />
          <!--    普通      -->
          <Component :is="item.type" v-else v-model="model[item.field]" style="width:100%" v-bind="item.props" @change="item.change" />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import { getLength } from '@/utils'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
export default {
  name: 'CargoForm',
  components: { CargoAdvanceSelect },
  props: {
    formItems: {
      type: Array,
      required: true
    },
    model: {
      type: Object,
      required: true
    },
    inline: {
      type: Boolean,
      default: () => false
    },
    labelPosition: {
      type: String,
      default: () => 'left'
    },
    labelWidth: {
      type: String,
      default: () => '100px'
    },
    labelSuffix: {
      type: String,
      default: () => ''
    },
    hideRequiredAsterisk: {
      type: Boolean,
      default: () => false
    },
    showMessage: {
      type: Boolean,
      default: () => false
    },
    inlineMessage: {
      type: Boolean,
      default: () => false
    },
    statusIcon: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      getLength,
      rules: {}
    }
  }
}
</script>
<style lang="scss">
.cargo-form{
  .el-form-item {
    &.label-none {
      .el-form-item__content{
        margin-left: 0;
      }
    }
  }
}
</style>
